import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Select, Button, Spin } from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {withTranslation} from 'react-i18next'
import {toJS} from 'mobx'
import history from '../../../routes/history'
const storage = window.localStorage

@inject('marketingResourcePoolStore', 'marketingSmsManagementStore', 'emailListStore', 'intelligentOutboundCallStore', 'accountStore')
@observer
class FormModal extends Component {
  state = {
    marketingType: undefined
  }

  formRef = React.createRef()

  componentDidMount() {
  }

  handleValuesChange = (changedValues) => {
    if (changedValues?.marketingType !== undefined) {
      this.setState({ marketingType: changedValues.marketingType })
    }
  }

  handleOk = () => {
    const {marketingResourcePoolStore, marketingSmsManagementStore, emailListStore, intelligentOutboundCallStore, accountStore, handleCancel, conditions, idList, record, type, poolObj} = this.props
    const {accountInfos} = accountStore
    const {selectedPhoneList, selectedEmailList, isAll} = marketingResourcePoolStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const {generateID} = marketingSmsManagementStore
    const phoneList = !isAll && selectedPhoneList.length>0 ? selectedPhoneList : null
    const emailList = !isAll && selectedEmailList.length>0 ? selectedEmailList : null
    this.formRef.current.validateFields().then(fieldsValue => {
      marketingResourcePoolStore.onImportAction({
        taskGroupId: generateID,
        poolId: record?.id,
        sourceType: '3',
        taskType: fieldsValue?.marketingType==='4'? '7' : fieldsValue?.marketingType,
        smsType: fieldsValue?.smsType,
        conditions: conditions,
        // idList: idList,
        phoneList,
        emailList,
        listId: poolObj?.id,
        marketGroupId: fieldsValue?.marketGroupId
      }).then(res=> {
        if (res?.data?.code === 0) {
          if(fieldsValue?.marketingType==='4'){
            history.push(`/intelligentCallManagement`,{
              taskType: fieldsValue?.marketingType,
              addModalVisible: true,
              marketGroupId: fieldsValue?.marketGroupId
            })
            accountStore.setSeletedItem('intelligentCallManagement')
            accountStore.onMenuClick(['intelligentCallManagement'])
            intelligentOutboundCallStore.onStatisticsAction(generateID)
            handleCancel()
          } else if(fieldsValue?.marketingType==='3'){
            history.push(`/emailList`,{
              taskType: fieldsValue?.marketingType,
              addModalVisible: true,
              marketGroupId: fieldsValue?.marketGroupId
            })
            accountStore.setSeletedItem('emailList')
            accountStore.onMenuClick(['emailList'])
            emailListStore.onAddressAction({
              'email': '',
              'taskGroupId': generateID,
              'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT
            }).then(resp=>{
              if(resp?.data?.code ===0) {
                handleCancel()
              }
            })
            emailListStore.onStatisticsAction({
              "taskGroupId": generateID,
            })
          } else {
            history.push(`/smsManagement`,{
              taskType: fieldsValue?.marketingType,
              smsType: fieldsValue?.smsType,
              addModalVisible: true,
              marketGroupId: fieldsValue?.marketGroupId
            })
            accountStore.setSeletedItem('smsManagement')
            accountStore.onMenuClick(['smsManagement'])
            if(fieldsValue?.smsType==='1') {
              marketingSmsManagementStore.onPhoneAction({
                'sourceType': '3',
                'phone': '',
                'taskGroupId': generateID,
                'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
                'page': 1,
                'size': PAGE_SIZE_DEFAULT
              }).then(resp=>{
                if(resp?.data?.code ===0) {
                  handleCancel()
                }
              })
            } else {
              marketingSmsManagementStore.onExcelViewAction({
                "configName": "",
                "marketGroupId": "",
                "sourceType": '3',
                "taskGroupId": generateID,
                'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
                'page': 1,
                'size': PAGE_SIZE_DEFAULT
              }).then(resp=>{
                if(resp?.data?.code ===0) {
                  handleCancel()
                }
              })
            }
            marketingSmsManagementStore.onStatisticsAction({
              "smsType": fieldsValue?.smsType,
              "taskGroupId": generateID,
              "taskType": fieldsValue?.marketingType,
            })
          }
          marketingResourcePoolStore.onChangeIsAll(false)
          marketingResourcePoolStore.onClearSelectedRowKeys([],[])
        }
      })
    }).catch(() => {})
  }
  render() {
    const { marketingResourcePoolStore, addModalVisible, handleCancel, record, type, t } = this.props
    const { isFetchingDetails, groupList, statusList } = marketingResourcePoolStore
    const statusLists = statusList?.filter(a=>record?.marketingType?.includes(a?.code))
    const groupLists = groupList?.filter(a=>record?.marketingGroupId?.includes(a?.id))
    return (
      <>
        <Modal
          title=''
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.editSend`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Spin spinning={isFetchingDetails}>
            <Form ref={this.formRef} key="addMapping" layout="vertical" onValuesChange={this.handleValuesChange}>
              <Row gutter={[10, 10]}>
                <Col span={24}>
                  <Form.Item name="marketingType" label={t(`marketingManagement.marketingClass`)}
                    rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingClass`)}`}]}
                  >
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                      {statusLists?.map((item, i) => (<Select.Option key={i} value={item?.code}>{item?.name}</Select.Option>))}
                    </Select>
                  </Form.Item>
                </Col>
                {this.state.marketingType === '1' || this.state.marketingType === '2' ? 
                <Col span={24}>
                  <Form.Item name="smsType" label={t(`marketingManagement.regularSMSType`)}
                    rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.regularSMSType`)}`}]}
                  >
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                      <Select.Option key='1' value='1'>{t('marketingManagement.regularSMS')}</Select.Option>
                      <Select.Option key='2' value='2'>{t('marketingManagement.personalizedSMS')}</Select.Option>
                    </Select>
                  </Form.Item>
                </Col> : null}
                <Col span={24}>
                  <Form.Item name="marketGroupId" label={t(`marketingManagement.marketingGroup`)}
                    rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingGroup`)}`}]}
                  >
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                      {groupLists?.map((item, i) => (<Select.Option key={i} value={item?.id}>{item?.groupName}</Select.Option>))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
